import { render, staticRenderFns } from "./AdminAccountDetails.vue?vue&type=template&id=32272f7d&scoped=true"
import script from "./AdminAccountDetails.vue?vue&type=script&lang=js"
export * from "./AdminAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountDetails.vue?vue&type=style&index=0&id=32272f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32272f7d",
  null
  
)

export default component.exports